// import 'createjs';
// import Alerttest from './modules/alerttest';

/**
 * サンプルクラス
 * @constructor
 */
class TopCanvas {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    // alert(4649);

    // const alerttest = new Alerttest();
    // alerttest.init();
  }
};

export default TopCanvas;
